var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "layoutFormRow",
    { staticClass: "inlineLabel bigger" },
    [
      _c(
        "Box",
        [
          _c(
            "Box",
            {
              staticClass: "amount-wrapper",
              attrs: { flex: 1, marginRight: 2 }
            },
            [
              _c(
                "Box",
                [
                  _c("NumberInput", {
                    attrs: { value: _vm.amount },
                    on: { change: _vm.onAmountChange }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "Box",
            { staticClass: "currency", attrs: { flex: 1 } },
            [
              !_vm.isCurrencyChangeable
                ? _c("UIInput", {
                    attrs: { disabled: true, value: _vm.currency }
                  })
                : _c(
                    "UISelect",
                    {
                      attrs: { value: _vm.currency },
                      on: { input: _vm.onCurrencyChange }
                    },
                    [
                      _c("option", [_vm._v("USD")]),
                      _c("option", [_vm._v("CAD")]),
                      _c("option", [_vm._v("NIS")])
                    ]
                  )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "Box",
        [
          _vm.showSavedConvertedAmount
            ? _c("layoutText", { attrs: { fontSize: 1, color: "#999" } }, [
                _vm._v("USD: " + _vm._s(_vm.formatMoney(_vm.convertedAmount)))
              ])
            : _vm._e(),
          _vm.convert
            ? _c(
                "layoutText",
                { attrs: { fontSize: 1, color: "#999" } },
                [
                  _vm._v(" USD: "),
                  _vm.loading
                    ? _c("Loading", { attrs: { inline: "" } })
                    : _c("span", [
                        _vm._v(
                          " " +
                            _vm._s(_vm.formatMoney(_vm.convertedLiveAmount)) +
                            _vm._s(
                              _vm.showTooltip
                                ? " (Amount will be updated on save)"
                                : null
                            ) +
                            " "
                        )
                      ])
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm.errorStr
        ? _c("span", { staticClass: "error-label" }, [
            _vm._v(_vm._s(_vm.errorStr))
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }